<template>
  <div>
    <el-group-title :title="title">
      <template slot="groupTitle">
        <el-table
          :data="tableData"
          :fit="true"
          @selection-change="selectionChange"
          border
          class="dic-sub-table-style01"
        >
          <el-table-column
            type="selection"
            width="50"
            v-if="showCheckBox"
            align="center"
            header-align="center"
          />
          <el-table-column
            type="index"
            width="50"
            :label="$t('page.contactInfo.contentLabel.xuhao')"
            align="center"
            v-if="showIndex"
          >
            <template #default="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <template v-for="(table, index) in tableHead">
            <el-table-column
              :key="index"
              :label="table.label"
              :width="table.width"
              :min-width="table.width"
              :prop="table.prop"
              :align="table.align"
              :header-align="table.headerAlign"
              :show-overflow-tooltip="true"
              :formatter="table.formatter"
              v-if="!table.template"
            >
              <template slot-scope="scope">
                <p v-if="table.slot === 'thawTime'">
                  <span v-if="scope.row.state == '1'">
                    {{ scope.row.thawTime }}</span
                  >
                  <span v-else>{{ scope.row.updateTime }}</span>
                </p>
                <p v-if="table.slot === 'opp'">
                  <a
                    v-if="Number(scope.row.uploadId) !== 0"
                    @click="download(scope.$index, scope.row)"
                    :title="$t('page.qualificationFile.file.clickdownload')"
                    style="color: #FF142F"
                  >{{ $t('page.qualificationFile.file.download') }}</a>
                  <span v-else></span>
                </p>
                <p v-if="table.slot === 'fileName'">
                  {{ scope.row.fileinfoType == '00' ?
                   $t('page.qualificationFile.tableTd.businessLicense')
                  :  scope.row.fileinfoType == '01' ?
                  $t('page.qualificationFile.tableTd.identityCard')
                  : scope.row.fileinfoType == '02' ?
                  $t('page.qualificationFile.tableTd.taxationImg') + $t('page.qualificationFile.tableTd.taxationImg2')
                  :scope.row.fileinfoType == '03' ?
                  $t('page.qualificationFile.tableTd.frameworkImg')
                  : scope.row.fileinfoType == '04' ?
                  $t('page.qualificationFile.tableTd.qualityControl')
                  : scope.row.fileinfoType == '05' ?
                  $t('page.qualificationFile.tableTd.organizationChart')
                  : scope.row.fileinfoType == '06' ?
                  $t('page.qualificationFile.tableTd.companyQualification')
                  : scope.row.fileinfoType == '07' ?
                  $t('page.qualificationFile.tableTd.productionLicence')
                  : scope.row.fileinfoType == '08' ?
                  $t('page.qualificationFile.tableTd.financialStatement')
                  : scope.row.fileinfoType == '09' ?
                  $t('page.qualificationFile.tableTd.cooperationFile')
                  : scope.row.fileinfoType == '10' ?
                  $t('page.qualificationFile.tableTd.specialIndustry')
                  : scope.row.fileinfoType == '11' ?
                  $t('page.qualificationFile.tableTd.distributiontImg')
                  : scope.row.fileinfoType == '21' ?
                  $t('page.qualificationFile.tableTd.cooperationFile')
                  : scope.row.fileinfoType == '15' ?
                  $t(
                  "page.qualificationFile.tableTd.businessLicenses"
                  )
                  :  scope.row.fileinfoType == '12' ?
                  $t('page.qualificationFile.tableTd.healthySafety')
                  : scope.row.fileinfoType == '13' ?
                  $t('page.qualificationFile.tableTd.environmentalManagement')
                  : scope.row.fileinfoType == '99' ?
                  $t('page.qualificationFile.tableTd.otherFiles')
                  : scope.row.fileinfoType == '30' ?
                  $t('page.qualificationFile.tableTd.transportation')
                  : scope.row.fileinfoTypeName

                }}
                </p>
                <p v-if="table.slot === 'fileType'">
                  {{ scope.row.fileTypeName == '图片' ? $t('page.qualificationFile.tableTd.img') : $t('page.qualificationFile.tableTd.file')}}
                </p>
                <span v-else-if="table.slot === 'size'">
                  {{ (scope.row.fileSize / 1024).toFixed(0) }}kb
                </span>
                <slot
                  v-else-if="table.slot"
                  :row="scope.row"
                  :$index="scope.$index"
                  :name="table.slot"
                >
                </slot>
                <template v-else>
                  <span
                    v-if="scope.row.required && scope.row.prop === table.prop"
                    style="color: #ff0000"
                    >*</span
                  >
                  {{ scope.row[table.prop] || "" }}
                  <span
                    v-if="
                      scope.row.fileinfoType === '02' &&
                        scope.row.prop === table.prop
                    "
                    style="color: #ff0000"
                    >{{ $t('page.qualificationFile.file.tip') }}</span
                  >
                </template>
              </template>
            </el-table-column>
          </template>
        </el-table>
      </template>
    </el-group-title>
    <!--   分页功能  -->
    <div class="table-footer" style="height:30px" v-if="type === 1">
      <div class="ccui-table-footer">
        <div id="ccui-paging">
          <el-pagination
            :total="tableData.length"
            :page-size="pageSize"
            :current-page="pageNo"
            prev-text="< 上一页"
            next-text="下一页 >"
            background
            layout="total, sizes, prev, pager, next, jumper"
            popper-class="ccui-paging-page-size-popper"
            @prev-click="handlePrev"
            @next-click="handleNext"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
          <el-button
            class="ccui-pagination-btn"
            size="mini"
            type="default"
            @click="handleGoPage('none')"
            >确定</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addUrlPerFix } from "@/utils";
import { bidSupplierMixin } from "@/views/mixins/mixin-bidSupplier"
export default {
  name: "supplier-table",
  mixins: [bidSupplierMixin],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    },
    tableHead: {
      type: Array,
      default: () => []
    },
    showCheckBox: {
      type: Boolean,
      default: false
    },
    showIndex: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: () => 0
    },
    downloadType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      pageNo: 1,
      pageSize: 10
    };
  },
  methods: {
    selectionChange(selection) {
      this.$emit("selectionChange", selection);
    },
    download(index, row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      if(this.downloadType == "fileUrl"){
        openUrl.href = `${addUrlPerFix(
          process.env.VUE_APP_BASE_URL
        )}/apis/sra/smc/downloadByUrl?fileUrl=${
          row.fileUrl
        }&fileName=${encodeURIComponent(row.fileName)}`;
      } else {
        openUrl.href = `${addUrlPerFix(
          process.env.VUE_APP_BASE_URL
        )}/apis/scpma/oss/downloadByUploadId?uploadId=${row.uploadId}`;
      }
      console.log(openUrl.href);
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.getStatusInfo();
    },
    handleCurrentChange(newNum) {
      this.pageNo = newNum;
      this.getStatusInfo();
    },
    handlePrev() {
      --this.props_pageNo;
      (this.pageNo = this.props_pageNo), (this.pageSize = this.props_pageSize);
      this.getStatusInfo();
    },
    handleNext() {
      ++this.props_pageNo;
      (this.pageNo = this.props_pageNo), (this.pageSize = this.props_pageSize);
      this.getStatusInfo();
    },
    handleGoPage(val) {
      this.props_pageNo = 1;
      if (val !== "none") {
        this.props_pageSize = val;
        // setSessionItem("pageSize", this.tableName, val);
      }
      (this.pageNo = this.props_pageNo), (this.pageSize = this.props_pageSize);
      this.getStatusInfo();
    }
  }
};
</script>

<style scoped></style>
